import { render, staticRenderFns } from "./PayslipSidebarSendInvoice.vue?vue&type=template&id=c0caf04c&"
import script from "./PayslipSidebarSendInvoice.vue?vue&type=script&lang=js&"
export * from "./PayslipSidebarSendInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports